/**
 * @pageName BlogCategories
 * @slotType dashboard plugin
 */
export type CategoriesBannerParams = EmptyParams;

/** @internal */
export type EmptyParams = {};

/**
 * @pageName BlogCategories
 * @slotType dashboard menu plugin
 */
export type CategoryItemMoreActionsMenuParams = ActionParams;

// These are used in the dev center, do not delete them
/** @internal */
export type ActionParams = {
  // ID of the selected item.
  selectedId: string;
};

/**
 * @pageName BlogCategories
 * @slotType dashboard menu plugin
 */
export type CategoryItemsBulkMoreActionsMenuParams = BulkActionParams;

/** @internal */
export type BulkActionParams = {
  // ID of the selected items.
  selectedIds: string[];
};
